import flatten from 'lodash.flatten';
import groupEntities from '../../group-entities';
import injectBanner from '../../inject-banner';

export default function getBannersForEntities(entitiesSet, banner) {
  const { interval, limit } = banner;
  const controlledLimit = limit || entitiesSet.length;

  const groups = groupEntities(entitiesSet, interval - 1);

  const entitiesWithBanner = groups.map(chunk => injectBanner(chunk, banner));

  const sanitizedEntities = flatten(entitiesWithBanner).slice(0, controlledLimit);

  return sanitizedEntities;
}
